var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.46154,
    y: 7.46154,
    width: 29.077,
    height: 29.077,
    rx: 4.846,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69231 1C4.33939 1 0 5.33939 0 10.6923V33.3077C0 38.6606 4.33939 43 9.69231 43H32.3077C37.6606 43 42 38.6606 42 33.3077V10.6923C42 5.33939 37.6606 1 32.3077 1H9.69231ZM11.3077 7.46154C8.63123 7.46154 6.46154 9.63124 6.46154 12.3077V31.6923C6.46154 34.3688 8.63124 36.5385 11.3077 36.5385H30.6923C33.3688 36.5385 35.5385 34.3688 35.5385 31.6923V12.3077C35.5385 9.63124 33.3688 7.46154 30.6923 7.46154H11.3077Z",
    fill: "url(#brandIconGradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandIconGradient",
    x1: 21,
    y1: 1,
    x2: 21,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17CEC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brand-icon.352f56fe174897f81276d868ebdafc9f.svg";
export { ForwardRef as ReactComponent };